export { default as productType } from "./productType.yaml";

export const appId = "wx9342fac75eef1111"

export const CDN_URL = "//static.hzwxbz3.cn/Lianyun/font_end/wap";
// ios防下架支付写死的游戏APPKEY
export const GetAppKey = () => {
  const appkey = localStorage.getItem("appkey");
  return appkey
};
const getEnv = function() {
  switch(window.location.hostname) {
    case "webpre.hzwxbz999.cn":
      return "//h5.hzwxbz999.cn"
    case "wap.yuwanc.com":
    case "wap.w2you.com":
    case "wap.bgyxy.com":
      return "//h5.yuwanc.com"
    case "wap-pre.yuwanc.com":
      return "//h5-pre.yuwanc.com"
    default:
      return "//h5.hzwxbz3.cn"
  }
};
export const API_URL = process.env.VUE_APP_IS_TEST ? "//h5.hzwxbz999.cn" : getEnv();
export const QI_DIAN_URL = "//wp.qiye.qq.com/qidian/2852152181/9618c1ef96579400e1e481819a96716e";
export const QI_DIAN_URL_QQ = "//q.url.cn/CD6n3U?_type=wpa&qidian=true";